import React from 'react';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import { StatusCode } from '../enums/responseStatus';
import { IconExclamationCircle } from '../mocks/stencilV4IconMocks';

import { IconClockSmall } from '@amzn/stencil-react-icons';
import { IconCheckCircleFillSmall } from '@amzn/stencil-react-icons';
import { IconInformationSmall } from '@amzn/stencil-react-icons';

export const getStatusIcon = status => {
  switch (status) {
    case StatusCode.IN_PROGRESS: {
      const IconClockWithTooltip = withTooltip()(IconClockSmall);
      return (
        <IconClockWithTooltip
          data-testid="in-progress-icon"
          tooltipText="In Progress"
          title="In progress"
          color="#3780bd"
        />
      );
    }

    case StatusCode.COMPLETED: {
      const IconCheckCircleWithTooltip = withTooltip()(IconCheckCircleFillSmall);
      return (
        <IconCheckCircleWithTooltip
          data-testid="completed-icon"
          tooltipText="Completed"
          title="Completed"
          color="green"
        />
      );
    }

    case StatusCode.ERROR: {
      const IconExclamationCircleWithTooltip = withTooltip()(IconExclamationCircle);
      return (
        <IconExclamationCircleWithTooltip
          data-testid="failed-icon"
          tooltipText="Failed"
          title="Failed"
          color="#a11d1d"
        />
      );
    }

    case StatusCode.SCHEDULED: {
      const IconClockWithTooltip = withTooltip()(IconClockSmall);
      return (
        <IconClockWithTooltip
          data-testid="scheduled-icon"
          tooltipText="Scheduled"
          title="Scheduled"
          color="#3780bd"
        />
      );
    }

    case StatusCode.DELETED: {
      const IconInformationCircleWithTooltip = withTooltip()(IconInformationSmall);
      return (
        <IconInformationCircleWithTooltip
          data-testid="deleted-icon"
          tooltipText="Deleted"
          title="Deleted"
          color="#5d6368"
        />
      );
    }

    default: {
      return '-';
    }
  }
};
